import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";

import {  allMediaFiles } from "../../../services/api"; 
import useSnackMessage from "../../../hooks/useSnackMessage"; 
import { updateState } from "../../../redux/commonSlice";
import { setAllMediaFilesArray } from "../../../redux/mediaFilesSlice";

export default (enableAllMediaRequest) => {

  const dispatch = useDispatch();
  const [showSnackbar] = useSnackMessage();
  const [enableAllMediaList, setEnableAllMediaList] = useState(enableAllMediaRequest);
  const [status, setStatus] = useState('')
  const commonReducer = useSelector(state=> state.root.commonReducer)
  const mediaFilesReducer = useSelector((state) => state.mediaFilesReducer);
 
  const {
    data: allMediaFilesData,
    isLoading: allMediaFilesLoading,
    error: allMediaFilesError,
    refetch: refetchAllMediaFiles,
  } = useQuery(
    [
      `allMediaFiles${commonReducer.user_id}`,
      commonReducer.user_id,
    ],
    () => allMediaFiles(),
    { enabled: enableAllMediaList, retry: false }
  );


  useEffect(() => {
    if(allMediaFilesLoading == true){
      setStatus('loading')
    }
  }, [allMediaFilesLoading]);


  useEffect(() => {
    if (allMediaFilesData) {
        setEnableAllMediaList(false);

        const mediaFiles = allMediaFilesData?.data?.data?.media_files;
        if(mediaFiles?.length == 0){
          setStatus('empty')
        }else{
          setStatus('success')
        }
        // setStatus('success')

      dispatch(
        setAllMediaFilesArray({
        all_media_files: mediaFiles,
        })
      );

    }
  }, [allMediaFilesData]);

  

  useEffect(() => {
    if(allMediaFilesError) {
      const errorObject = allMediaFilesError?.response?.data;
      showSnackbar(errorObject);
      setStatus('error')
      // dispatch(setSnackbar({ ...setSnackMessageType(responseObject) }));
 
    }
   
  }, [allMediaFilesError]);


 

  return [refetchAllMediaFiles, status];
};